import { render, staticRenderFns } from "./ModalSelectPeriodoForAportes.vue?vue&type=template&id=0454931a&"
import script from "./ModalSelectPeriodoForAportes.vue?vue&type=script&lang=js&"
export * from "./ModalSelectPeriodoForAportes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports